import { render, staticRenderFns } from "./forgotPassword.vue?vue&type=template&id=6a69467c&scoped=true"
import script from "./forgotPassword.vue?vue&type=script&lang=js"
export * from "./forgotPassword.vue?vue&type=script&lang=js"
import style0 from "@/styles/components/login/input.scss?vue&type=style&index=0&prod&lang=scss&external"
import style1 from "@/styles/components/login/index.scss?vue&type=style&index=1&id=6a69467c&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a69467c",
  null
  
)

export default component.exports